// @flow

import UIEvents from '../../../../service/UI/UIEvents';
import { OPEN_LOBBY } from '../../lobby/actionTypes';
import { setPrejoinPageVisibility, setSkipPrejoinOnReload } from '../../prejoin';
import { MHConferenceErrors } from '../lib-meet-hour';
import { USER_WAITING_REGISTER } from '../premeeting/components/web/constants';
import { MiddlewareRegistry } from '../redux';
import { stopSound, unregisterSound } from '../sounds';
import { TOGGLE_SCREENSHARING } from '../tracks/actionTypes';

import { CONFERENCE_FAILED, CONFERENCE_JOINED, LOADING_CHECKER, MH_CONFERENCE_JOINED } from './actionTypes';
import { inIframe } from './functions';
import './middleware.any';

declare var APP: Object;


MiddlewareRegistry.register(({ dispatch, getState }) => next => action => {
    const { enableForcedReload } = getState()['features/base/config'];

    switch (action.type) {
    case CONFERENCE_JOINED: {
        const result = next(action);

        if (enableForcedReload) {
            dispatch(setPrejoinPageVisibility(false));
            dispatch(setSkipPrejoinOnReload(false));
        }
        dispatch({
            type: OPEN_LOBBY,
            lobbyscreen: {
                _isLobbyScreenVisible: false,
                _isPrejoin: false
            }
        });
        dispatch(stopSound(USER_WAITING_REGISTER));
        dispatch(unregisterSound(USER_WAITING_REGISTER));

        // console.log('jwt stored', jwtDecode(_jwtStored));
        if (document.getElementById('videospace')) {
            document.getElementById('videospace').style.display = 'block';

        }
        const styleB = document.querySelector('.new-toolbox');

        if (styleB) {
            styleB.style.display = 'block';
        }


        // document.getElementById('sideToolbarContainer').style.display = 'block';
        // if (document.head) {
        //     const linkStyle = document.querySelector('#linkStyle') || null;
        //     const scriptFile = document.querySelector('#mainJS') || null;

        //     if (linkStyle) {
        //         linkStyle.remove();
        //     }
        //     if (scriptFile) {
        //         scriptFile.remove();
        //     }
        // }

        setTimeout(() => {
            dispatch({
                type: MH_CONFERENCE_JOINED,
                mhconferenceJoined: true
            });


            dispatch({
                type: LOADING_CHECKER,
                isPrejoinLoading: false
            });

            const query = document.querySelector('.watermark');

            if (query && inIframe()) {
                query.style.zIndex = 1;
            }

            // _userJoinedMeeting(dispatch, getState);
        }, 3000);

        return result;
    }
    case CONFERENCE_FAILED: {
        enableForcedReload
            && action.error?.name === MHConferenceErrors.CONFERENCE_RESTARTED
            && dispatch(setSkipPrejoinOnReload(true));

        break;
    }
    case TOGGLE_SCREENSHARING: {
        if (typeof APP === 'object') {
            APP.UI.emitEvent(UIEvents.TOGGLE_SCREENSHARING);
        }

        break;
    }
    }

    return next(action);
});


// /**
//  * 描述.
//  *
//  * @param {any} dispatch - Dispatch Function.
//  * @param {any} getState - GetState function.
//  * @returns {any}
//  */
// async function _userJoinedMeeting(dispatch, getState) {
//     try {
//         const format1 = 'YYYY-MM-DD HH:mm:ss';
//         const currentDateTime = moment().format(format1);
//         const bowser = new BrowserDetection();
//         const browserName = bowser.getName();
//         let accessType = 'web';
//         const participant = getLocalParticipant(getState());

//         for (const i in bowserNameToJitsiName) {
//             if (i !== browserName) {
//                 accessType = 'app';
//             }
//         }
//         const roomName = getBackendSafeRoomName(getState()['features/base/conference'].room);
//         let dataJson;


//         try {
//             const getData = await fetchApi('https://geolocation-db.com/json/0f761a30-fe14-11e9-b59f-e53803842572')
//             .catch(e => console.log('Error in fetching geolocation bros', e?.status));


//             if (getData) {
//                 dataJson = await getData.json();
//             }
//         } catch (errors) {
//             try {
//                 const getData = await fetchApi('geolocation', 'get', {
//                     'Content-Type': 'application/json'
//                 }).catch(e => console.log('Error in fetching geolocation bros', e?.status));

//                 // eslint-disable-next-line max-depth
//                 if (getData) {
//                     dataJson = await getData.json();
//                 }
//             // eslint-disable-next-line no-catch-shadow
//             } catch (error) {
//                 console.log('Error in fetching geolocation bros', error);

//             }


//         }

//         const { occurenceId } = getState()['features/base/mtApi'];

//         const userObject = {
//             // eslint-disable-next-line camelcase
//             meeting_id: roomName,
//             name: participant?.name,
//             // eslint-disable-next-line camelcase
//             occurrence_id: occurenceId,
//             // eslint-disable-next-line camelcase
//             is_host: getState()['features/base/jwt'].jwt ? 1 : 0,
//             // eslint-disable-next-line camelcase
//             email_id: participant?.email,
//             // eslint-disable-next-line camelcase
//             login_datetime: currentDateTime,
//             // eslint-disable-next-line camelcase
//             user_agent: browserName,
//             // eslint-disable-next-line camelcase
//             access_type: accessType,
//             ip: dataJson?.IPv4
//         };


//         const userJson = JSON.stringify(userObject);
//         const sendUserData = await fetchApi('meeting/save_meeting_attendance',
//             'post',
//              {
//                  'Content-Type': 'application/json'
//              },
//             userJson
//         );

//         await sendUserData.json();
//     } catch (e) {
//         console.log('%c Error in fetching geolocation', 'background: #222; color: #bada55');
//     }
// }
